(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /**
   * Duyuru barindaki mesajlari sirayla gosterir.
   *
   * Tek mesaj varsa hic calismaz. Sekme arka plandayken duruyor: gorunmeyen
   * bir animasyonu dondurmek bosa pil harcamak.
   */
  (function () {
    var rotator = document.querySelector('[data-bar-rotator]');
    if (!rotator) return;

    var messages = rotator.querySelectorAll('[data-bar-message]');
    if (messages.length < 2) return;

    var seconds = parseFloat(rotator.dataset.interval);
    if (!seconds || seconds < 1) seconds = 4;

    var index = 0;
    var timer = null;

    function show(next) {
      messages[index].classList.remove('is-active');
      index = next;
      messages[index].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      timer = setInterval(function () {
        show((index + 1) % messages.length);
      }, seconds * 1000);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  })();

  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (this.form) {
        if (this.form.requestSubmit) {
          this.form.requestSubmit();
        } else {
          this.form.submit();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    function openDrawer() {
      if (typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
    }
    function closeDrawer() {
      if (drawer.open) drawer.close();
    }

    function syncCount() {
      var src = drawer.querySelector('[data-drawer-count]');
      if (!src) return;
      var value = src.textContent.trim();
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = value;
        el.classList.toggle('is-empty', value === '0');
      });
    }

    function applySection(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        syncCount();
      }
    }

    function addToCart(form) {
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) applySection(data.sections['cart-drawer']);
          openDrawer();
        })
        .catch(function () { form.submit(); });
    }

    function changeLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) applySection(data.sections['cart-drawer']);
        });
    }

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) { event.preventDefault(); changeLine(parseInt(remove.dataset.line, 10), 0); return; }
      if (event.target === drawer) closeDrawer();
    });

    document.querySelectorAll('[data-cart-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        if (typeof drawer.showModal === 'function') { event.preventDefault(); openDrawer(); }
      });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.matches && form.matches('[data-product-form]')) {
        event.preventDefault();
        addToCart(form);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var dialog = document.getElementById('MobileMenu');
    var openers = document.querySelectorAll('[data-menu-open]');
    var closers = document.querySelectorAll('[data-menu-close]');

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
        btn.setAttribute('aria-expanded', 'true');
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog) dialog.close();
      });
    });

    if (dialog) {
      dialog.addEventListener('close', function () {
        openers.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    var disclosures = document.querySelectorAll('.header__nav [data-disclosure]');
    var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

    function closeAll(except) {
      disclosures.forEach(function (item) {
        if (item !== except) item.open = false;
      });
    }

    disclosures.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (canHover.matches) {
          closeAll(item);
          item.open = true;
        }
      });
      item.addEventListener('mouseleave', function () {
        if (canHover.matches) item.open = false;
      });
      var summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function () {
          closeAll(item);
        });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.header__nav')) closeAll(null);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /**
   * Adet degisikligini kendisi gonderir.
   *
   * Adim dugmeleri eskiden yalnizca girdinin degerini degistiriyordu; sepeti
   * gerçekten guncelleyen sey "Guncelle" butonuydu. Buton kaldirilinca
   * gonderme isi buraya gecti. Gecikme, ust uste tiklamalarin her birinde
   * ayri istek atilmasini onluyor.
   */
  (function () {
    var form = document.querySelector('.cart form');
    if (!form) return;

    var pending = null;

    function submitSoon() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        form.submit();
      }, 600);
    }

    form.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById(btn.dataset.qtyTarget);
        if (!input) return;
        var step = parseInt(btn.dataset.qtyStep, 10);
        var val = parseInt(input.value, 10) || 0;
        input.value = Math.max(0, val + step);
        submitSoon();
      });
    });

    form.querySelectorAll('[name="updates[]"]').forEach(function (input) {
      input.addEventListener('change', submitSoon);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (this.form) this.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /**
   * Kampanya geri sayimi.
   *
   * Iki kip var ve ayrimi bilincli:
   *  - Bitis tarihi girilirse GERCEK bir son tarih sayilir; herkes ayni ani
   *    gorur ve sure bitince blok gizlenir.
   *  - "Ziyaretciye ozel sure" girilirse sayac her ziyaretci icin bastan
   *    baslar ve tarayicida saklanir. Bu bir ikna araci, gercek bir son tarih
   *    degil; o yuzden varsayilan degil ve panelde boyle anlatiliyor.
   */
  (function () {
    var boxes = document.querySelectorAll('[data-promo-timer]');
    if (!boxes.length) return;

    function endsAt(box) {
      var deadline = box.dataset.deadline;
      if (deadline) {
        var parsed = Date.parse(deadline);
        return isNaN(parsed) ? null : parsed;
      }

      var minutes = parseInt(box.dataset.rollingMinutes, 10);
      if (!minutes || minutes < 1) return null;

      var key = box.dataset.storageKey;
      var saved = null;
      try { saved = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (saved && saved > Date.now()) return saved;

      var next = Date.now() + minutes * 60000;
      try { localStorage.setItem(key, String(next)); } catch (e) {}
      return next;
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    boxes.forEach(function (box) {
      var target = endsAt(box);
      if (!target) return;

      var clock = box.querySelector('[data-promo-clock]');
      box.hidden = false;

      function tick() {
        var left = target - Date.now();
        if (left <= 0) {
          box.hidden = true;
          return;
        }
        var total = Math.floor(left / 1000);
        var hours = Math.floor(total / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        clock.textContent = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
        clock.setAttribute('datetime', 'PT' + hours + 'H' + minutes + 'M' + seconds + 'S');
        requestAnimationFrame(function () {
          setTimeout(tick, 1000);
        });
      }
      tick();
    });
  })();

  (function () {
    var root = document.querySelector('.product');
    if (!root) return;

    var mainImg = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImg) {
          mainImg.src = btn.dataset.full;
          mainImg.removeAttribute('srcset');
        }
        root.querySelectorAll('[data-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    var lightbox = root.querySelector('[data-lightbox]');
    var lightboxImg = root.querySelector('[data-lightbox-image]');
    if (lightbox && lightboxImg && mainImg) {
      mainImg.addEventListener('click', function () {
        lightboxImg.src = mainImg.src;
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      });
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox || event.target.closest('[data-lightbox-close]')) lightbox.close();
      });
    }

    var qty = root.querySelector('[data-qty]');
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        var step = parseInt(btn.dataset.qtyStep, 10);
        var val = parseInt(qty.value, 10) || 1;
        qty.value = Math.max(1, val + step);
      });
    });

    var dataEl = root.querySelector('[data-product-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var optionEl = root.querySelector('[data-variant-option]');
    var skuEl = root.querySelector('[data-sku]');
    var skuWrap = root.querySelector('[data-sku-wrap]');

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('.product__option').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function equal(a, b) {
      return a.length === b.length && a.every(function (x, i) { return x === b[i]; });
    }

    function update() {
      var opts = currentOptions();
      if (!opts.length) return;
      var match = variants.find(function (v) { return equal(v.options || [], opts); });
      if (!match) {
        if (addBtn) addBtn.disabled = true;
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (optionEl) optionEl.textContent = opts[0];
      if (skuWrap) {
        if (match.sku) {
          if (skuEl) skuEl.textContent = match.sku;
          skuWrap.hidden = false;
        } else {
          skuWrap.hidden = true;
        }
      }
      if (compareEl) {
        if (match.compare_at) {
          compareEl.textContent = match.compare_at;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.addLabel : addBtn.dataset.soldoutLabel;
      }
    }

    root.querySelectorAll('.product__option input[type=radio]').forEach(function (r) {
      r.addEventListener('change', update);
    });
  })();

  (function () {
    var widthField = document.querySelector('[data-wall-width]');
    var heightField = document.querySelector('[data-wall-height]');
    if (!widthField || !heightField) return;

    var KEY = 'papier:wall-size';

    function inRange(field) {
      var value = parseInt(field.value, 10);
      if (!value) return false;
      return value >= Number(field.min) && value <= Number(field.max);
    }

    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (saved.width) widthField.value = saved.width;
      if (saved.height) heightField.value = saved.height;
    } catch (e) {}

    function remember() {
      var payload = {};
      if (inRange(widthField)) payload.width = widthField.value;
      if (inRange(heightField)) payload.height = heightField.value;
      try { localStorage.setItem(KEY, JSON.stringify(payload)); } catch (e) {}
    }

    widthField.addEventListener('input', remember);
    heightField.addEventListener('input', remember);
  })();

  (function () {
    var wrap = document.querySelector('[data-description]');
    if (!wrap) return;
    var body = wrap.querySelector('[data-description-body]');
    var toggle = wrap.querySelector('[data-description-toggle]');
    if (!body || !toggle) return;
    if (body.scrollHeight <= body.clientHeight + 24) {
      body.style.maxHeight = 'none';
      toggle.hidden = true;
    }
  })();

  (function () {
    var dialog = document.querySelector('[data-doku-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var image = dialog.querySelector('[data-doku-image]');
    var title = dialog.querySelector('[data-doku-title]');
    var text = dialog.querySelector('[data-doku-text]');

    document.querySelectorAll('[data-doku-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        image.src = btn.dataset.image;
        image.alt = btn.dataset.name;
        title.textContent = btn.dataset.name;
        text.textContent = btn.dataset.text || '';
        text.hidden = !btn.dataset.text;
        dialog.showModal();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-doku-close]')) dialog.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.pcar').forEach((root) => {
    const track = root.querySelector('[data-pcar-track]');
    const nav = root.querySelector('[data-pcar-nav]');
    if (!track || !nav) return;

    const prev = root.querySelector('[data-pcar-prev]');
    const next = root.querySelector('[data-pcar-next]');

    const overflows = () => track.scrollWidth - track.clientWidth > 4;

    const sync = () => {
      nav.hidden = !overflows();
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };

    const step = (dir) => {
      const item = track.querySelector('.pcar__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      const width = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: dir * width * Math.max(1, Math.floor(track.clientWidth / width) - 1) });
    };

    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
